export enum DigitalJourneyRoute {
  Landing = "/:session",
  Welcome = "/:session/welcome",
  VehicleType = "/:session/vehicle-type",
  AccidentTimeAndLocation = "/:session/accident-time",
  TypeOfClaim = "/:session/type-of-claim",
  AccidentInformation = "/:session/accident-information",
  AccidentCircumstance = "/:session/accident-circumstance",
  VehicleCondition = "/:session/vehicle-condition",
  DamageLocationPH = "/:session/ph-vehicle-damage-location",
  PHPersonalDetails = "/:session/ph-personal-details",
  OtherDriverPersonalDetails = "/:session/other-personal-details",
  DamageLocationOther = "/:session/other-vehicle-damage-location",
  InjuredPeopleDetails = "/:session/injured-people-details",
  CAIPhotos = "/:session/cai-photos",
  InjuredPeopleDocumentPhotos = "/:session/injured-document-photos",
  AuthoritiesDocumentsPhotos = "/:session/authorities-document-photos",
  AdditionalDocumentsPhotos = "/:session/additional-documents-photos",
  SelectBodyShop = "/:session/select-bodyshop",
  AdditionalInformation = "/:session/additional-information",
  HandlingDecision = "/:session/handle-decision",
  DamagePhotoCapture = "/:session/damage-photo-capture",
  VehiclePhotoCapture = "/:session/vehicle-photo-capture",
  CompleteClaimInCustomerPortal = "/:session/complete-the-claim",
  ClaimSummary = "/:session/digital-journey-claim-summary",
  FlowCompleted = "/:session/digital-journey-completed",
  SelectWindowsDamaged = "/:session/select-windows-damaged",
  TypeOfClaimTheftFire = "/:session/type-of-claim-theft-fire",
  TypeOfClaimNaturalEvent = "/:session/type-of-claim-natural-event",
  TypeOfClaimInsuranceToActivate = "/:session/type-of-claim-insurance-to-activate",
  WrongDevice = "/error/wrong-device",
  InvalidSession = "/error/invalid-session",
  ExpiredSession = "/error/expired-session",
  BrowserNotSupported = "/error/browser-not-supported",
  ApiError = "/error/api-error",
  CatchAll = "*",
}
